import { LitElement, html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { AtlCardEvents, AtlContactCardWithButtonProps, CardTags } from './card.types.ts';
import classNames from 'classnames';
import { getGlobalStyleSheets } from '../../global-styles';
import { ifDefined } from 'lit/directives/if-defined.js';
import { ButtonEnums } from '../button/index.ts';

import Styles from './contact-card-with-button.scss?inline';

@customElement(CardTags.ContactCardWithButton)
export class AtlContactCardWithButton
   extends LitElement
   implements AtlContactCardWithButtonProps
{
   static styles = [
      ...getGlobalStyleSheets(),
      Styles
   ];

   @property({ attribute: 'contact-mail', type: String },)
   contactMail: string;

   @property({ attribute: 'contact-name', type: String })
   contactName: string;

   @property({ attribute: 'contact-position', type: String })
   contactPosition: string;

   @property({ type: String })
   internalId?: string;

   @property({ type: String })
   internalClassName?: string;

   @property({ type: String })
   initials: string;

   @property({ type: String })
   cardTitle: string;
   
   @property({ type: String })
   avatar?: string;

   @property({ type: String })
   avatarAlt?: string;
   
   @property({ type: Boolean })
   fixedSize?: boolean;

   @property({ type: Boolean })
   hasViewTeamCallback: boolean;

   render() {
      let contactMailLink = this.contactMail;
      if (contactMailLink && !contactMailLink.startsWith('mailto:')) {
         contactMailLink = `mailto:${contactMailLink}`;
      }

      const title = () => {
         if (this.cardTitle?.length > 0) {
            return html` <span class="card-title"> ${this.cardTitle} </span> `;
         }

         return nothing;
      };
      const avatar = () => {
         if (this.avatar) {
            return html`
               <img src="${this.avatar}" alt=${ifDefined(this.avatarAlt)} />
            `;
         }
         if (this.initials) {
            return html` <div data-letters=${this.initials}></div> `;
         }

         return html`<i
            aria-hidden="true"
            class="fa-solid fa-user menu-icon"
         ></i>`;
      };

      return html`
         <div
            id=${this.internalId ?? 'atl-contact-card-id'}
            class=${classNames(
               'card contact-card',
               { 'fixed-size': this.fixedSize === true },
               this.internalClassName
            )}
            part="contact-card"
         >
            ${title()}
            <div class="card-body">
               <div class="contact-item">
                  <div class="contact-avatar">${avatar()}</div>
                  <div class="contact-text">
                     <span>${this.contactName}</span>
                     <small>${this.contactPosition}</small>
                     <a class="text-primary" href=${contactMailLink}
                        >${this.contactMail}</a
                     >
                  </div>
               </div>
               ${this.hasViewTeamCallback
                  ? html` <div class="contact-cta mt-4">
                       <atlantis-button
                          variant="${ButtonEnums.ButtonVariant.Cta}"
                          iconName="users"
                          @click=${() => this._HandleViewTeamCallBack()}
                       >
                          <span
                             class="d-flex align-items-center justify-content-center "
                          >
                             <span class="ps-2 "> View team </span>
                          </span>
                       </atlantis-button>
                    </div>`
                  : nothing}
            </div>
         </div>
      `;
   }

   protected _HandleViewTeamCallBack() {
      const event = new CustomEvent(AtlCardEvents.ContactCardButtonClick, {
         bubbles: true,
         composed: true,
      });
      this.dispatchEvent(event);
   }
}
